import React from 'react';
const stamenslogo = `/images/logo.svg`;

function Scheduleacall() {
    
    
  return (
    <div className="modal fade" id="exampleModalcall" tabIndex="-1" aria-hidden="true">
    <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content popup-modal-call-details">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
            <div className="modal-body">
              <div className="text-center d-block w-100 py-4">
                <a className="pb-2 ps-2 d-block" href="#"><img src={stamenslogo} alt="main logo" height="53" width="124" className="img-fluid" /></a>
              </div>
              <div className="call-details">
                  <div className="part">
                      <h3 className="heading"><i className="fa fa-phone" aria-hidden="true"></i> Telephone</h3>
                      <a href="tel:+911203500847" className="d-block">+91-120 3500 847, 48</a>
                  </div>
                  <div className="part">
                      <h3 className="heading"><i className="fa fa-envelope" aria-hidden="true"></i> Write to us</h3>
                      <a href="mailto:contact@stamenssoftware.com">contact@stamenssoftware.com</a>
                  </div>
              </div>
            </div>
        </div>
    </div>
</div>

  )

}

export default Scheduleacall;